import 'css-chunksrc/client/scenes/milestone/details/styles.scss';export default {
  "details": "_details_1jbcd_1",
  "header": "_header_1jbcd_5",
  "title": "_title_1jbcd_11",
  "icon": "_icon_1jbcd_15",
  "name": "_name_1jbcd_20",
  "input": "_input_1jbcd_30",
  "description": "_description_1jbcd_40",
  "label": "_label_1jbcd_44",
  "paragraph": "_paragraph_1jbcd_50",
  "advancement": "_advancement_1jbcd_60",
  "percentage": "_percentage_1jbcd_67",
  "progressBar": "_progressBar_1jbcd_76",
  "advancementLabel": "_advancementLabel_1jbcd_81",
  "descriptionMaxChars": "_descriptionMaxChars_1jbcd_88",
  "loader": "_loader_1jbcd_93",
  "loaderMain": "_loaderMain_1jbcd_101"
};